<template>
    <div>
        <b-tabs v-model="activetab" pills content-class="m-0" card>
            <b-tab :title="$t('Produkter')" no-body lazy>
                <AdminProductList :data="products" product-name="elslutbleck" product-code="eb"
                    @on-deleted-item="fetchEb"></AdminProductList>
            </b-tab>
            <b-tab :title="$t('Kriterier')" no-body lazy>
                <AdminEbOptionsList></AdminEbOptionsList>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
// import AdminEbList from "@/components/admin/AdminEbList";
import AdminProductList from "./AdminProductList.vue";
import AdminEbOptionsList from "@/components/admin/AdminEbOptionsList";
import ApiServiceAdmin from "@/services/ApiServiceAdmin";
export default {
    components: {
        // AdminEbList,
        AdminProductList,
        AdminEbOptionsList
    },
    data() {
        return {
            products: [],
            totalForSlug: {},
            activetab: 0
        }
    },
    methods: {
        fetchEb() {
            ApiServiceAdmin.getEb().then((response) => {
                console.log('data', response.data)
                this.products = response.data;
            });
        },
    },
    mounted() {
        this.fetchEb();
    },
}

</script>